import { qreq } from "../shared/qrequest";
import BaseCom from "./common/BaseCom";
import DataTable from "./common/DataTable";
import Icon from "./common/Icon";
import { withParamsAndNavigate } from "./common/WithParamsAndNavigate";
import { NavMenuGlobal } from "./NavMenu";
import { Pop } from "./common/PopModal";
import Globals from "../shared/Globals";
import Tick from "./common/Tick";
import { Modal } from "react-bootstrap";
import L from "./common/Lang";
import FormInput from "./common/FormInput";

class SyncPoolList extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            list: [],
            instances: []
        };
    }

    async componentDidMount() {
        NavMenuGlobal.setPath('Sync Pool');
        await this.load();
        await this.loadInstances();
    }

    componentWillUnmount() {
        NavMenuGlobal.clearTitle();
    }

    load = async () => {
        try {
            let j = await qreq.getAsync('/api/sync-pool/list');
            if (j.list) {
                this.setState({ list: j.list, refreshDate: Globals.toMDYHMAMPMLocalDateString(new Date(), true) });
            }
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
    }

    loadInstances = async () => {
        try {
            let j = await qreq.getAsync('/api/instance/list');
            if (j.list) {
                this.setState({ instances: j.list });
            }
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
    }

    commit = (item) => {
        item.syncCredential = {};
        this.setState({ currentItem: item, showAssignKey: true });
    }

    commitSubmit = async (e) => {
        e?.preventDefault();
        this.setState({ submitting: true });
        const info = { ...this.state.currentItem };
        try {
            let j = await qreq.postAsync('/api/sync-pool/commit', info);
            if (j.errorCode === 0) {
                this.success('Commited!');
                this.load();
            }
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
        this.setState({ submitting: false });
    }

    delete = (item) => {
        let title = item.publicKey;
        if (title.length > 16)
            title = title.substring(0, 16) + '...';
        Pop.showConfirm(`Are you sure you want to delete '${title}' from pool?`, 'Delete Key', () => {
            qreq.post('/api/sync-pool/delete', { id: item.id }, j => {
                if (j.errorCode === 0) {
                    this.success('Key deleted successfully.');
                    this.componentDidMount();
                }
                else
                    this.alert(j.errorMessage);
            }, this.unkownErrorCallback);
        });
    }

    render() {
        return <div className="container-fluid">
            <p><i>Refreshes automatically: {this.state.refreshDate}</i></p>
            <Tick interval={5000} onTick={this.load} />
            <DataTable columns={[
                {
                    name: 'publicKey', title: 'Public Key', valueFunc: row => <input type="text" className="form-control" value={row.publicKey} />
                },
                {
                    name: 'createdDate',
                    title: 'Connection Date',
                    valueFunc: row => Date.parse(row.createdDate) > Date.parse('2000-01-01') ? Globals.toMDYHMLocalDateStringOrDiff(row.createdDate) : 'N/A'
                },
                {
                    name: 'actions',
                    valueFunc: row => <div className="d-flex gap-1">
                        <button type="button" className="btn btn-primary" onClick={() => this.commit(row)}><Icon icon="faPlugCircleBolt" /></button>
                        <button type="button" className="btn btn-danger" onClick={() => this.delete(row)}><Icon icon="faTrash" /></button>
                    </div>,
                    width: '100px'
                }
            ]} data={this.state.list} />

            {/* MODAL */}
            <Modal show={this.state.showAssignKey} onHide={() => this.setState({ showAssignKey: false })}>
                <Modal.Header>
                    <Modal.Title>
                        <L>Assign Key</L>
                    </Modal.Title>
                </Modal.Header>
                {this.state.currentItem && <form onSubmit={this.commitSubmit}>
                    <Modal.Body>
                        <FormInput model={this.state.currentItem.syncCredential} name="instanceID" label="Instance" type="select" options={this.state.instances} required />
                        <FormInput model={this.state.currentItem.syncCredential} name="name" label="Name" required />
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="submit" className="btn btn-success btn-lg" onClick={() => this.setState({ showAssignKey: false })} disabled={this.state.submitting}><Icon icon="faSave" /> <L>Save</L></button>
                        <button type="button" className="btn btn-secondary btn-lg" onClick={() => this.setState({ showAssignKey: false })} disabled={this.state.submitting}><Icon icon="faClose" /> <L>Close</L></button>
                    </Modal.Footer>
                </form>}
            </Modal>

        </div>;
    }
}

export default withParamsAndNavigate(SyncPoolList);